"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertIcon = exports.StyledAlertIcon = exports.mapColorToClassName = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var FontAwesomeIcon_1 = __importDefault(require("../../../FontAwesomeIcon"));
var mapColorToClassName = function (color) {
    switch (color) {
        case "warning":
            return "fa fa-exclamation-circle";
        case "primary":
            return "fa fa-info-circle";
        case "success":
            return "fa fa-check-circle";
        case "danger":
            return "fa fa-minus-circle";
        default:
            return null;
    }
};
exports.mapColorToClassName = mapColorToClassName;
exports.StyledAlertIcon = styled_components_1.default(FontAwesomeIcon_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return style_utils_1.colorSelector(props, props.color, 500); });
var AlertIcon = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (react_1.default.createElement(exports.StyledAlertIcon, __assign({}, props, { color: color, iconClassName: exports.mapColorToClassName(color), "aria-hidden": "true" })));
};
exports.AlertIcon = AlertIcon;
exports.default = exports.AlertIcon;
var templateObject_1;
//# sourceMappingURL=index.js.map